import * as React from 'react';

function SvgSquaresFour(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M10.5 4.5h-6v6h6v-6zM19.5 4.5h-6v6h6v-6zM10.5 13.5h-6v6h6v-6zM19.5 13.5h-6v6h6v-6z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgSquaresFour;
